// import React from 'react';
// import { Link } from 'react-router-dom';

// const CtaSection = () => {
//   return (
//     <section className="cta-section">
//       {/* Background Image with Parallax */}
//       <div
//         className="bg-image"
//         data-parallax='{"x": 40}'
//         style={{
//           backgroundImage: 'url(/images/resource/image-1.png)'
//         }}
//       ></div>

//       {/* Floating Offer Image */}
//       <div className="offer-image">
//         <img src="/images/resource/image-8.png" alt="Summer Offer" />
//       </div>

//       <div className="auto-container">
//         <div className="row">
//           <div className="col-xl-5 offset-xl-7 cta-block">
//             <div className="title-box text-light">
//               <div className="sub-title">Our offer</div>
//               <h2 className="sec-title">Summer Offer</h2>
//             </div>
//             <div className="text">
//               Benefit from a 10% discount, making your reservations with a minimum of 3 days in advance
//             </div>
//             <div className="link-btn">
//               <Link to="/services" className="theme-btn btn-style-one">
//                 <span>find out more</span>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CtaSection;


import React from 'react';
import { Link } from 'react-router-dom';

const CtaSection = () => {
  return (
    <section className="cta-section">
      {/* Background Image with Parallax */}
      <div
        className="bg-image bgimg"
        data-parallax='{"x": 40}'
        // style={{
        //   backgroundImage: 'url(/images/resource/image-111.jpg)'
        // }}
      ></div>

      {/* Floating Image (kept same) */}
      {/* <div className="offer-image">
        <img src="/images/resource/image-8.png" alt="Woodland Escape" />
      </div> */}

      <div className="auto-container">
        <div className="row">
          <div className="col-xl-5 offset-xll-7 cta-block">
            <div className="title-box text-light">
              <div className="sub-title">escape into nature</div>
              <h2 className="sec-title">
                Discover Peace <br /> in the Heart of the Jungle
              </h2>
            </div>
            <div className="text">
              Reconnect with nature at Woodland Escape — where serenity, adventure, and comfort come together.
              Enjoy cozy stays, delicious meals, and unforgettable moments surrounded by greenery and wildlife.
            </div>
            <div className="link-btn">
              <Link to="/about" className="theme-btn btn-style-one">
                <span>discover more</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
